import React from "react";
import "./SupplierCard.css";

const SupplierCard = ({ supplier, onCardClick }) => {
  return (
    <div className='suppliercard' onClick={(e) => onCardClick(supplier)}>
      <div className='scardheader'>
        <h2>{supplier.companyCode}</h2>
        {/* <p style={{ textAlign: "right" }}>{user.active === "y" ? "Active" : "Disabled"}</p> */}
      </div>
      <div className='scardbody'>
        <li>
          <p>Company Name:</p>
          <p>{supplier.companyName}</p>
        </li>
        <li>
          <p>Address:</p>
          <p>{supplier.streetAddress}</p>
        </li>
        <li>
          <p>City:</p>
          <p>{supplier.city}</p>
        </li>
        <li>
          <p>Country:</p>
          <p>{supplier.country}</p>
        </li>
        <li>
          <p>Region:</p>
          <p>{supplier.region}</p>
        </li>
      </div>
    </div>
  );
};

export default SupplierCard;
